<template>
    <div class="page-content header-clear-medium">

		<div v-if="loading">
			<EventSekeleton :count="3" :color-info="{ 'bg-pink-dark' : true }" />
		</div>
		<div v-else>
			<div class="card card-style mt-5 overflow-visible">
				<img :src="student_image" width="100" height="100" style="margin-top: -50px;" class="mx-auto preload-img rounded-circle shadow-xl">
				<div class="content text-center">
					<div class="px-3 mb-n2">
						<h3 class="font-700">{{ student_name }}</h3>
						<p class="mb-2 font-16">
							{{ student_classroom }}
						</p>
					</div>
				</div>
			</div>

			<div class="content">
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col-12 col-md-6 pe-0">
									<label for="">Tipe Filter</label>
									<div class="form-custom form-label form-icon mb-0">
											<i class="bi bi-sliders font-13"></i>
											<select v-model="filterData.type" @change="onChangeFilter()" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
													<option value="all" selected="">Semua</option>
													<option value="monthly">Bulanan</option>
													<option value="daily">Harian</option>
													<option value="range">Range Tanggal</option>
											</select>
											<!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
											<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
									</div>
							</div>
							<div class="col-12 col-md-6 pe-0" v-if="filterData.type == 'daily'">
									<label for="">Tanggal</label>
									<div class="form-custom form-label form-icon mb-0">
											<i class="bi bi-calendar font-12"></i>
											<input type="date" class="form-control rounded-xs" id="c5" @change="onChangeFilter()" v-model="filterData.date">
											<!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
											<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
									</div>
							</div>
							<div class="col-12 col-md-6 pe-0" v-if="filterData.type == 'range'">
								<div class="row">
									<div class="col-lg-6">
										<label for="">Tanggal Dari</label>
										<div class="form-custom form-label form-icon mb-0">
												<i class="bi bi-calendar font-12"></i>
												<input type="date" class="form-control rounded-xs" id="c5" @change="onChangeFilter()" v-model="filterData.date_from">
												<!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
												<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
										</div>
									</div>
									<div class="col-lg-6">
										<label for="">Tanggal Sampai</label>
										<div class="form-custom form-label form-icon mb-0">
												<i class="bi bi-calendar font-12"></i>
												<input type="date" class="form-control rounded-xs" id="c5" @change="onChangeFilter()" v-model="filterData.date_to">
												<!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
												<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-6 pe-0" v-if="filterData.type == 'monthly'">
									<label for="">Bulan</label>
									<div class="form-custom form-label form-icon mb-0">
										<i class="bi bi-calendar font-12"></i>
										<select v-model="filterData.month" @change="onChangeFilter()" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
												<option value="" selected="">- Pilih Bulan -</option>
												<option value="01">Januari</option>
												<option value="02">Febuari</option>
												<option value="03">Maret</option>
												<option value="04">April</option>
												<option value="05">Mei</option>
												<option value="06">Juni</option>
												<option value="07">Juli</option>
												<option value="08">Agustus</option>
												<option value="09">September</option>
												<option value="10">Oktober</option>
												<option value="11">November</option>
												<option value="12">Desember</option>
										</select>
										<!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
										<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<h4 class="text-center mb-3"><span class="badge bg-pink-dark color-white">{{ dataArrTatibs.length }} Pelanggaran</span></h4>

			<div v-for="item in dataArrTatibs" :key="item.id" class="card card-style cursor-pointer" @click="showDetailTatib(item)">
				<div class="content">
					<div class="d-flex">
						<div class="align-self-top me-3">
							<span class="icon icon-xxl bg-yellow-dark color-white rounded-m"><i class="bi bi-exclamation-triangle-fill font-28"></i></span>
						</div>
						<div>
							<h4 class="font-20 font-800">{{ item.chapter_title }}</h4>
							<p class="mt-0 mb-2">
								{{ item.date | getDateIndoWithDayAndTime }}
							</p>
							<p class="color-dark-dark"><strong>{{ item.chapter_point }} Point</strong></p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Portal to="offcanvas-modal-bottom" :order="1">
            <div v-show="show_detail_tatib" :data-bs-scroll="!show_detail_tatib" data-bs-backdrop="false" class="offcanvas-custom offcanvas offcanvas-bottom rounded-m offcanvas-detached bg-theme show" style="visibility: visible;" id="offcanvas-tatib-detail">
                <div class="content">
                    <div class="d-flex pb-2">
                        <div class="align-self-center">
                            <h5 class="mb-n1 color-highlight font-700 text-uppercase pt-1 text-center">{{ selectedTatibDetail.chapter_title }}</h5>
                            <!-- <h1 class="font-700">Share Duo</h1> -->
                        </div>
                        <div class="align-self-center ms-auto">
                            <a ref="hide-offcanvas-literacy-form" @click="hideDetailTatib" href="javascript:void(0)" class="icon icon-m"><i class="bi bi-x-circle-fill color-red-dark font-18 me-n4"></i></a>
                        </div>
                    </div>

					<div class="d-flex mb-2 flex-column align-items-center">
						<div class="d-flex flex-row">
							<i class="bi bi-person-circle color-blue-dark font-16"></i>
							<p class="font-16 ms-2"><strong>{{ student_name }}</strong></p>
						</div>
						<div class="d-flex flex-row ms-3">
							<i class="bi bi-eye-fill color-blue-dark font-16"></i>
							<p class="font-16 ms-2"><strong>{{ selectedTatibDetail.date | getDateIndoWithDayAndTime }}</strong></p>
						</div>
					</div>

					<img :src="selectedTatibDetail.chapter_image" width="200" class="rounded mx-auto d-block mt-3" alt="Image Tatib">

					<p class="text-center">{{ selectedTatibDetail.clause_content }}</p>

					<h5 class="font-16 text-center">Pasal {{ selectedTatibDetail.chapter_number }} Ayat {{ selectedTatibDetail.clause_number }}</h5>
                </div>
            </div>

            <div v-show="show_detail_tatib_backdrop" class="offcanvas-backdrop fade show"></div>
        </Portal>
        
    </div>
</template>

<script>
import moment from 'moment';
import { 
	mapMutations, 
	mapActions, mapState 
} from 'vuex'

import EventSekeleton from "../components/skeleton/EventSekeleton.vue";

export default {
    name: 'TatibPage',
    components: {
		EventSekeleton
    },
    data() {
        return {
					preloadImageDummy: require('@/assets/image-dummy/no-profil-image.png'),
					profileImageDummy: require('@/assets/image-dummy/1s.jpg'),
					tatibImageDummy: require('@/assets/image-dummy/no-smoking.jpg'),
					show_detail_tatib: false,
					show_detail_tatib_backdrop: false,
					selectedTatibDetail: {},
					dataArrTatibs: [],
					filterData: {
						type: "all",
						date: moment().format('YYYY-MM-DD'),
						date_from: moment().format('YYYY-MM-DD'),
						date_to: moment().format('YYYY-MM-DD'),
						month: moment().format('MM'),
						year: moment().format('YYYY'),
					}
        }
    },
    async created() {
			this.SET_LOADING()
			await this.groupingTatibs({ type: this.filterData.type })
			this.CLEAR_LOADING()
    },
    methods: {
			...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
			...mapActions('tatib', ['getTatibs']),
			async groupingTatibs(params) {
				let tempArrTatibs = []
				let tatibs = await this.getTatibs(params)
				tatibs.data.forEach(element => {
					// console.log(element.clauses)
					element.clauses.forEach(elementClauses => {
						elementClauses.data.forEach(elementClausesData => {
							let arrTempListTatib = {
								chapter_title : element.name,
								chapter_point : elementClauses.point,
								chapter_image : element.url_icon,
								chapter_number : element.number,
								clause_number : elementClauses.number,
								clause_content : elementClauses.content,
								id : elementClausesData.id,
								date: elementClausesData.date
							}
							tempArrTatibs.push(arrTempListTatib)
						})
					})
				})

				tempArrTatibs.sort(function(a, b){return new Date(b.date) - new Date(a.date)})
				
				this.dataArrTatibs = tempArrTatibs
			},
			showDetailTatib(tatibDetailItem) {
				this.selectedTatibDetail = tatibDetailItem
				this.show_detail_tatib = true
				this.show_detail_tatib_backdrop = true
			},
			hideDetailTatib() {
							this.show_detail_tatib = false
							this.show_detail_tatib_backdrop = false
			},
			async onChangeFilter() {
				const { type, date, date_from, date_to, month, year } = this.filterData;
				switch (type) {
					case 'all':
						await this.groupingTatibs({ type: type })
						break;
					case 'yearly':
						await this.groupingTatibs({ type: type, time: year })
						break;
					case 'monthly':
						await this.groupingTatibs({ type: type, time: month })
						break;
					case 'daily':
						await this.groupingTatibs({ type: type, time: date })
						break;
					case 'range':
						await this.groupingTatibs({ type: type, date_from, date_to })
						break;
					default:
						break;
				}
			}
    },
    computed: {
			...mapState({
					loading: state => state.loading,
					student_name: state => state.student_name,
					student_image: state => state.student_image,
					student_classroom: state => state.student_classroom,
			}),
			...mapState('tatib', {
					tatibs: state => state.tatibs
			}),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
</style>
